import Labelled from './Labelled';

export { Props, Action, Error, labelID, errorID, helpTextID } from './Labelled';
export default Labelled;
